"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Pagination = /** @class */ (function () {
    function Pagination(data) {
        Object.assign(this, data);
    }
    return Pagination;
}());
exports.Pagination = Pagination;
//# sourceMappingURL=pagination.class.js.map